module.exports = "https://web-assets-production.autolist.com/_next/static/images/minivan-0c1ea53dbf755483a16e8bda6750a27b.jpg";